type SelectOption = {
    id: string;
    text: string;
    data?: {
        [key: string]: string;
    };
};

export enum Filters {
    radius = 'radius',
    section = 'section'
}

export const OPTIONS: Record<Filters, SelectOption[]> = {
    [Filters.radius]: [
        {
            id: '0',
            text: 'This area only',
            data: {
                value: '0'
            }
        },
        {
            id: '0.25',
            text: 'Within ¼ miles',
            data: {
                value: '0.25'
            }
        },
        {
            id: '0.5',
            text: 'Within ½ miles',
            data: {
                value: '0.5'
            }
        },
        {
            id: '1',
            text: 'Within 1 miles',
            data: {
                value: '1'
            }
        },
        {
            id: '3',
            text: 'Within 3 miles',
            data: {
                value: '3'
            }
        },
        {
            id: '5',
            text: 'Within 5 miles',
            data: {
                value: '5'
            }
        },
        {
            id: '10',
            text: 'Within 10 miles',
            data: {
                value: '10'
            }
        },
        {
            id: '15',
            text: 'Within 15 miles',
            data: {
                value: '15'
            }
        },
        {
            id: '20',
            text: 'Within 20 miles',
            data: {
                value: '20'
            }
        },
        {
            id: '30',
            text: 'Within 30 miles',
            data: {
                value: '30'
            }
        },
        {
            id: '40',
            text: 'Within 40 miles',
            data: {
                value: '40'
            }
        }
    ],
    [Filters.section]: [
        {
            id: 'all',
            text: 'Show all residential',
            data: {
                value: 'find-agents'
            }
        },
        {
            id: 'estate-agents',
            text: 'Estate agents',
            data: {
                value: 'find-agents/estate-agents'
            }
        },
        {
            id: 'letting-agents',
            text: 'Letting agents',
            data: {
                value: 'find-agents/letting-agents'
            }
        },
        {
            id: 'commercial-agents',
            text: 'Commercial agents',
            data: {
                value: 'find-agents/commercial-agents'
            }
        }
    ]
};
